import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, DestroyRef, ElementRef, inject, Input, OnInit } from '@angular/core';
import { DownloadExcelPaddleQrModalService } from 'app/router-wrapper/services/download-excel-paddle-qr-modal.service';
import { CookieService } from 'ngx-cookie-service';
import * as ExcelJS from 'exceljs/dist/exceljs';
import { Sizes } from 'app/enums/sizes.enum';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'app-download-excel-paddle-qr-modal',
  standalone: true,
  templateUrl: './download-excel-paddle-qr-modal.component.html',
  styleUrl: './download-excel-paddle-qr-modal.component.scss',
  imports: [FormsModule, ReactiveFormsModule, MdbSelectModule,],
})
export class DownloadExcelPaddleQrModalComponent implements OnInit, AfterViewInit {
  destroyRef = inject(DestroyRef)
  @Input() data = null;

  public form: UntypedFormGroup;

  public options = [{
    id: Sizes.SMALL,
    label: 'Small (100x100)'
  }, {
    id: Sizes.MEDIUM,
    label: 'Medium (200x200)'
  }, {
    id: Sizes.LARGE,
    label: 'Large (400x400)'
  }];
  
  constructor(
    private downloadExcelPaddleQrModalService: DownloadExcelPaddleQrModalService,
    private element: ElementRef,
    private cookieService: CookieService,
    private http: HttpClient,
    private formBuilder: UntypedFormBuilder,
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      qrCodeSize: ['']
    });

    this.form.get('qrCodeSize').setValue(Sizes.MEDIUM);
  }


  ngAfterViewInit(): void {
    const styles = window['documentManager'].createElement('link');
    styles.href = 'paybee-spa/styles.css?v=398';
    styles.rel = 'stylesheet';
    window['$'](this.element.nativeElement).append(styles);
  }

  onDownloadClick() {
    const size = this.form.get('qrCodeSize').value;
    this.downloadExcelFile(size);
  }

  downloadExcelFile(size) {
    const list = [1, 2, 4];
    const multiplier = list[size];
    
    /* Adjust row and column sizes depending on qrCode size */
    const qrCodeSize = 100 * multiplier;
    const qrColumnWidth = 13 * multiplier;
    const rowHeight = 60 * multiplier;
    const imageSize = { width: 100 * multiplier, height: 100 * multiplier }; ;


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Guests');

    worksheet.getRow(1).height = 15; // set standart height for the header

    const columns = [
      { header: 'Name', headerStyle: { bold: true }, width: 20 },
      { header: 'Email', headerStyle: { bold: true }, width: 20 },
      { header: 'Paddle Number', headerStyle: { bold: true }, width: 15 },
      { header: 'Table', headerStyle: { bold: true }, width: 15 },
      { header: 'Paddle QR Code', headerStyle: { bold: true }, width: qrColumnWidth },
    ];

    worksheet.columns = columns;

    this.getEventExportData(qrCodeSize).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((data: any) => {
      const textDataList = [];
      const imageList = [];

      data.forEach((item) => {
        const textData = {
          attendeeName: item.attendeeName,
          attendeeEmail: item.attendeeEmail,
          paddleNum: item.paddleNum,
          tableNum: item.tableNum
        }
        textDataList.push(textData);
        imageList.push(item.qrCodeImage);
      })

      for (let i = 0; i < data.length; i++) {
        const textData = textDataList[i];
        const values = Object.values(textData);
        const row = worksheet.addRow(values);

        row.height = rowHeight;
        row.eachCell((cell) => {
          cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        })

        const imageData = imageList[i];
        const image = workbook.addImage({
          base64: `data:image/png;base64,${imageData}`,
          extension: 'png'
        });

        worksheet.addImage(image, {
          tl: { col: 4.05, row: (i + 1) + 0.05}, // add some space at the top and left of the image
          ext: imageSize
        });
      }

      workbook.xlsx.writeBuffer().then((buffer) => {
        this.saveAsExcelFile(buffer);
        this.onCloseClick();
      });
    })
  }

  private saveAsExcelFile(buffer){
    const blob: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = 'event_paddle_qr_code_only';
    downloadLink.click();
    
  }

  getEventExportData(qrCodeSize) {
    const params = { 
      eventId: this.data.eventId,
      qrCodeSize: qrCodeSize
    }
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(JSON.stringify(params))}`
    ];
    return this.http.post('api/event/paddle/data', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  }

  onCloseClick() {
    this.downloadExcelPaddleQrModalService.close();
  }
}
